import { render, staticRenderFns } from "./HiboCheckbox.vue?vue&type=template&id=182379d6&"
import script from "./HiboCheckbox.vue?vue&type=script&lang=ts&"
export * from "./HiboCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports